import { useState } from 'react';

export default function LightboxVideo() {
    const [videoDisplay, setVideoDisplay] = useState(false);

    const showVideo = () => {
        setVideoDisplay(true);
    };

    const hideVideo = () => {
        setVideoDisplay(false);
    };

    return (
        <>
            <hzn-button
                variant="primary"
                tone="inverse"
                hzn-aria-label="Watch video: Carmax Auction Experience"
                onClick={showVideo}>
                learn more
            </hzn-button>
            {videoDisplay ? (
                <div
                    id="videoBox"
                    className="videoBox align-center"
                    onClick={hideVideo}
                    aria-hidden="true">
                    <iframe
                        title="Player"
                        src="https://player.vimeo.com/video/530471267"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            ) : (
                ''
            )}
        </>
    );
}
